//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { rando } from '@nastyox/rando.js'

export default {
  mounted () {
    this.tl = gsap.timeline({
      onComplete: (...args) => {
        this.$emit('complete', ...args)
      }
    })

    this.tl.set(
      ['#object-1','#object-2', '#object-3', '#object-4', '#object-5', '#object-6'],
      { scale: 0.5, opacity: 0, rotate: () => rando(-15, 15) + 'deg', transformOrigin: `50% 50%` }
    )

    this.tl.set('#card', { scale: 0.5, opacity: 0, rotate: '-20deg', transformOrigin: `50% 50%` })

    // this.tl.set('#card', { transformOrigin: `${105 - 526/2}px ${147}px` })
    // this.tl.set('#card', { rotate: '-10deg', })

    this.tl.to('#card', { scale: 1, opacity: 1, rotate: '-10deg', duration: 1.5 })

    this.tl.to(
      ['#object-1', '#object-2', '#object-3', '#object-4', '#object-5', '#object-6'],
      {
        scale: 1,
        opacity: 1,
        stagger: 0.1,
        rotate: '0deg',
        duration: 0.3,
        ease: 'expo.out'
      }
    )

    // this.tl.to(
    //   ['#card', '#object-1', '#object-2', '#object-3', '#object-4', '#object-5', '#object-6'],
    //   {
    //     scale: 0.5,
    //     opacity: 0,
    //     duration: 0.1,
    //     delay: 3
    //   }
    // )
  },
  beforeDestroy () {
    this.tl.kill()
  }
}
